export default __webpack_public_path__ + "static/media/call-a-person-contact-img2.5089438d.svg";